import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaPhone, FaEnvelope, FaTimes, FaComments } from 'react-icons/fa';
import './EnquireButton.css';

const EnquireButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleWhatsApp = () => {
    window.open('https://wa.me/919731395805?text=Hi, I would like to enquire about your tour packages', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+919731395805';
  };

  const handleEmail = () => {
    window.location.href = 'mailto:tours@ksaholidays.in?subject=Tour Enquiry';
  };

  return (
    <div className="enquire-button-container">
      {/* Floating Action Button */}
      <button 
        className={`enquire-fab ${isOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Enquire Now"
      >
        {isOpen ? <FaTimes /> : <FaComments />}
        {!isOpen && <span className="fab-text">Enquire</span>}
      </button>

      {/* Quick Action Buttons */}
      <div className={`enquire-menu ${isOpen ? 'active' : ''}`}>
        <button 
          className="enquire-option whatsapp"
          onClick={handleWhatsApp}
          title="WhatsApp Us"
        >
          <FaWhatsapp />
          <span>WhatsApp</span>
        </button>

        <button 
          className="enquire-option call"
          onClick={handleCall}
          title="Call Us"
        >
          <FaPhone />
          <span>Call Now</span>
        </button>

        <button 
          className="enquire-option email"
          onClick={handleEmail}
          title="Email Us"
        >
          <FaEnvelope />
          <span>Email Us</span>
        </button>

        <Link 
          to="/contact"
          className="enquire-option contact"
          title="Contact Form"
          onClick={() => setIsOpen(false)}
        >
          <FaComments />
          <span>Contact Form</span>
        </Link>
      </div>

      {/* Overlay */}
      {isOpen && <div className="enquire-overlay" onClick={toggleMenu}></div>}
    </div>
  );
};

export default EnquireButton;
